var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDevops3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 122,
    viewBox: "0 0 105 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3455_7609)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 26.596C0 16.9298 7.83604 9.09375 17.5023 9.09375H69.0817C78.7479 9.09375 86.584 16.9298 86.584 26.596V78.2405C86.584 87.9068 78.7479 95.7428 69.0817 95.7428H17.5023C7.83605 95.7428 0 87.9068 0 78.2405V26.596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5023 9.6407H69.0817C78.4459 9.6407 86.037 17.2319 86.037 26.596V78.2405C86.037 87.6047 78.4459 95.1959 69.0817 95.1959H17.5023C8.13812 95.1959 0.546947 87.6047 0.546947 78.2405V26.596C0.546947 17.2318 8.13811 9.6407 17.5023 9.6407Z",
    stroke: "#B1C1CF",
    strokeWidth: 1.09389
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.8903 46.9897V40.6762H51.5769V42.7807H41.0546V39.624C41.054 39.066 40.8321 38.5311 40.4376 38.1365C40.043 37.742 39.5081 37.5201 38.9501 37.5195H30.5322C29.9742 37.5201 29.4393 37.742 29.0447 38.1365C28.6502 38.5311 28.4283 39.066 28.4277 39.624V48.0419C28.4283 48.5999 28.6502 49.1348 29.0447 49.5294C29.4393 49.9239 29.9742 50.1458 30.5322 50.1464H38.9501C39.5081 50.1458 40.043 49.9239 40.4376 49.5294C40.8321 49.1348 41.054 48.5999 41.0546 48.0419V44.8852C41.8915 44.886 42.694 45.2189 43.2858 45.8107C43.8776 46.4025 44.2104 47.2049 44.2113 48.0419V57.512H37.8979V55.4075H31.5844V61.721H37.8979V59.6165H44.2113V61.721C44.2118 62.2789 44.4337 62.8139 44.8283 63.2084C45.2228 63.603 45.7578 63.8249 46.3157 63.8254H51.5769V65.9299H57.8903V59.6165H51.5769V61.721H46.3157V54.3553H51.5769V56.4598H57.8903V50.1464H51.5769V52.2508H46.3157V48.0419C46.3119 46.8999 45.9329 45.7908 45.2372 44.8852H51.5769V46.9897H57.8903ZM30.5322 48.0419V39.624H38.9501V48.0419H30.5322ZM35.7934 59.6165H33.6889V57.512H35.7934V59.6165ZM53.6814 61.721H55.7859V63.8254H53.6814V61.721ZM53.6814 52.2508H55.7859V54.3553H53.6814V52.2508ZM53.6814 42.7807H55.7859V44.8852H53.6814V42.7807Z",
    fill: "#243251"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3455_7609",
    x: -17.5023,
    y: 0.342604,
    width: 121.589,
    height: 121.653,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8.75115
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.75115
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.615686 0 0 0 0 0.686275 0 0 0 0 0.776471 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3455_7609"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3455_7609",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevops3);
export default __webpack_public_path__ + "static/media/Devops3.965b54bf38b07760d92eefc389747381.svg";
export { ForwardRef as ReactComponent };